import React, { useState } from "react";

import { LoadingState } from "../utils/enum";
import { fetchDriverDetails, fetchDrivers } from "../services/equipmentAPI";
import { Driver, Equipment } from "../models";
import { DriverContextModel } from "../models/Driver";

type DriverProviderProps = {
  children?: React.ReactNode;
};

export const DriverContext = React.createContext<DriverContextModel>(
  {} as DriverContextModel
);

export const DriverProvider = ({ children }: DriverProviderProps) => {
  const [assignableDrivers, setAssignableDrivers] = useState<Driver[]>([]);
  const [searchedAssignableDrivers, setSearchedAssignableDrivers] = useState<
    Driver[]
  >([]);
  const [assignDrawerOpen, setAssignDrawerOpen] = useState(false);
  const [isFilteringActive, setIsFilteringActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filterAvailability, setFilterAvailability] = useState<boolean>();
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [selectedDriverID, setSelectedDriverID] = useState<string>();
  const [selectedDriver, setSelectedDriver] = useState<Driver>();
  const [loadingState, setLoadingState] = useState<LoadingState>(
    LoadingState.Pending
  );
  const [loadingDetailsState, setLoadingDetailsState] = useState<LoadingState>(
    LoadingState.Pending
  );
  const [loadingAssignable, setLoadingAssignable] = useState(
    LoadingState.Pending
  );

  const listDrivers = async () => {
    try {
      setLoadingState(LoadingState.Pending);
      const response = await fetchDrivers();
      setDrivers(response.data);
      setLoadingState(LoadingState.Success);
    } catch (e) {
      setLoadingState(LoadingState.Error);
    }
  };

  const listAssignableDrivers = async () => {
    try {
      setLoadingAssignable(LoadingState.Pending);
      const response = await fetchDrivers();
      const result = response.data || [];
      console.log("drivers", result);
      setAssignableDrivers(result);
      setLoadingAssignable(LoadingState.Success);
    } catch (e) {
      setLoadingAssignable(LoadingState.Error);
    }
  };

  const searchAssignableDrivers = async (searchTerm: string) => {
    const search = searchTerm.trim().toLowerCase();

    // Implement search locally
    const searchedItems = assignableDrivers.filter((driver) => {
      const isValid =
        driver.name.toLowerCase().includes(search) ||
        driver.email.toLowerCase().includes(search) ||
        driver.phoneNumber.toLocaleLowerCase().includes(search);
      return isValid;
    });

    setSearchedAssignableDrivers(searchedItems);
  };

  const getDriverDetails = async (driverID: string) => {
    try {
      setLoadingDetailsState(LoadingState.Pending);
      const response = await fetchDriverDetails(driverID);
      setSelectedDriver(response.data);
      setLoadingDetailsState(LoadingState.Success);
    } catch (e) {
      setLoadingDetailsState(LoadingState.Error);
    }
  };

  // const handleToastError = ({
  //   title,
  //   description,
  //   error,
  // }: {
  //   error: any;
  //   title: string;
  //   description: string;
  // }) => {
  //   const isAxiosError = axios.isAxiosError(error);

  //   toast({
  //     title: title,
  //     position: "top",
  //     status: "error",
  //     isClosable: true,
  //     description: isAxiosError
  //       ? (error as AxiosError<any>).response?.data?.message ?? description
  //       : description,
  //   });
  // };

  const values: DriverContextModel = {
    assignableDrivers,
    loadingAssignable,
    searchedAssignableDrivers,
    assignDrawerOpen,
    selectedDriver,
    setAssignDrawerOpen,
    searchAssignableDrivers,
    listAssignableDrivers,
    listDrivers,
  };

  return (
    <DriverContext.Provider value={values}>{children}</DriverContext.Provider>
  );
};
